var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-12 form-page px-md-5" },
          [
            _c("div", { staticClass: "row header align-items-center" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h2", { staticClass: "page-header" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("dashboard.welcomeBack")) +
                      "\n            "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "clickable text-primary",
                      on: { click: _vm.goToSettings },
                    },
                    [_vm._v(_vm._s(_vm.agentName))]
                  ),
                  _vm._v("!\n          "),
                ]),
                _vm._v(" "),
                _c("h6", { staticClass: "subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("dashboard.whatsGoingOn")) + "!"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.showTutorial ? _c("tutorial") : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row mt-4",
                attrs: { id: "informational-cards-container" },
              },
              [
                _c("informational-card", {
                  attrs: {
                    "info-type": "Mortgage",
                    "is-loading": _vm.mortgageCardLoading,
                    "info-text": _vm.$t(
                      "dashboard.informationalCards.mortgageRenewals"
                    ),
                    "number-of-days": _vm.mortgageDays,
                  },
                  on: {
                    click: _vm.openMortgageModal,
                    loaded: function ($event) {
                      _vm.mortgageCardLoading = false
                    },
                  },
                }),
                _vm._v(" "),
                _c("informational-card", {
                  attrs: {
                    "info-type": "Activity",
                    "info-text": _vm._f("capitalize")(
                      _vm.$tc("global.words.activity", 2)
                    ),
                    "number-of-days": _vm.activityDays,
                    past: _vm.expired,
                  },
                  on: { click: _vm.openActivityModal },
                }),
                _vm._v(" "),
                _c("informational-card", {
                  attrs: {
                    "info-type": "Birthday",
                    "info-text": _vm.$tc(
                      "dashboard.informationalCards.birthday",
                      2
                    ),
                    "number-of-days": _vm.birthdayDays,
                  },
                  on: { click: _vm.openBirthdayModal },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row justify-content-center no-gutters" },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-12 col-lg-8 col-xxl-7 pr-lg-4",
                    attrs: { id: "task-calendar-col" },
                  },
                  [_c("dashboard-calendar")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dashboard-activity col-12 col-lg-4 col-xxl-5",
                  },
                  [
                    _vm.showDirectToLender
                      ? _c(
                          "div",
                          { attrs: { id: "submissions-activity-wrapper" } },
                          [
                            _c(
                              "div",
                              { staticClass: "card mb-3" },
                              [_c("d2l-submissions")],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        attrs: {
                          id: _vm.showDirectToLender
                            ? "submissions-activity-wrapper"
                            : "clients-activity-wrapper",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card" },
                          [_c("clients-activity")],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row justify-content-center no-gutters" },
              [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "div",
                    {
                      staticClass: "row justify-content-center",
                      attrs: { id: "charts" },
                    },
                    [
                      _c("apps-received-chart"),
                      _vm._v(" "),
                      _c("closes-chart"),
                      _vm._v(" "),
                      _c("stages-chart"),
                      _vm._v(" "),
                      _c("completed-chart"),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("informational-modal", {
        ref: "mortgageModal",
        attrs: {
          "info-type": "Mortgage",
          "loading-items": _vm.loadingItems,
          "info-text": _vm.$t("dashboard.informationalCards.mortgageRenewals"),
          "number-of-days": _vm.mortgageDays,
          "number-of-clients": _vm.numberOfClients.mortgage,
          completed: _vm.completedApplications,
        },
        on: { change: _vm.loadMortgages },
      }),
      _vm._v(" "),
      _c("informational-modal", {
        ref: "activityModal",
        attrs: {
          "info-type": "Activity",
          "loading-items": _vm.loadingItems,
          "info-text": _vm.$tc("global.words.activity", 2),
          "number-of-days": _vm.activityDays,
          "number-of-clients": _vm.numberOfClients.activity,
          expired: _vm.expired,
        },
        on: { change: _vm.loadActivities },
      }),
      _vm._v(" "),
      _c("informational-modal", {
        ref: "birthdayModal",
        attrs: {
          "info-type": "Birthday",
          "loading-items": _vm.loadingItems,
          "info-text": _vm.$tc("dashboard.informationalCards.birthday", 2),
          "number-of-clients": _vm.numberOfClients.birthday,
          "number-of-days": _vm.birthdayDays,
        },
        on: { change: _vm.loadBirthdays },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }